import { ErrorMessage, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { InputGroup } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl'
import Loader from '../../../components/Loader'
import ModelComponent from '../../../components/Modal'
import ReactSelect from '../../../components/ReactSelect'
import TextError from '../../../components/TextError'
import { redirectTo } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _headerMenuImg_ } from '../../../lib/ImagePath'
import { _alphabetRegex_, _integerRegex_ } from '../../../lib/Regex'

const ManageBannerModel = ({
  modalShow,
  setModalShow,
  fetchData,
  editData,
  setEditData,
  setToast,
  toast,
  setLoading,
  loading
}) => {
  const [dropDownData, setDropDownData] = useState()
  const location = useLocation()
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png']

  const fetchDropDownData = async (
    endpoint,
    queryString = '?pageindex=0&PageSize=0',
    setterFunc
  ) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint,
      queryString
      //      headers: {
      //     'Access-Control-Allow-Origin': '*',
      // }
    })
      .then((res) => {
        setLoading(false)
        if (res.status === 200 && res?.data?.data) {
          return setterFunc(res?.data?.data)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (editData) {
      let endpoint = ''
      switch (editData?.redirectTo) {
        case 'Product List':
          endpoint = 'MainCategory/getEndCategory'
          break

        case 'Static Page':
          endpoint = 'ManageStaticPages'
          break

        case 'Landing Page':
          endpoint = 'LendingPage'
          break

        case 'Collection Page':
          endpoint = 'ManageCollection'
          break

        default:
          break
      }
      endpoint &&
        fetchDropDownData(endpoint, '?pageindex=0&PageSize=0', (data) => {
          setDropDownData(data)
        })
    }
  }, [editData])

  const onSubmit = async (values, resetForm) => {
    setLoading(true)
    let dataofForm = {
      Name: values.name,
      Image: values?.imageFile ? values?.imageFile.name : values?.image,
      ImageFile: values?.imageFile,
      ImageAlt: values?.imageAlt,
      HasLink: values?.hasLink,
      RedirectTo: values?.redirectTo,
      LendingPageId: values?.lendingPageId,
      CategoryId: values?.categoryId,
      StaticPageId: values?.staticPageId,
      CollectionId: values?.collectionId,
      CustomLink: values?.customLink,
      Sequence: values?.sequence,
      IsImageAvailable: values?.imageFile || values?.image ? true : false
    }

    if (values?.id) {
      dataofForm = { ...dataofForm, Id: values?.id }
    }

    const submitFormData = new FormData()

    const keys = Object.keys(dataofForm)

    keys.forEach((key) => {
      submitFormData.append(key, dataofForm[key])
    })
    let method = values?.id ? 'PUT' : 'POST'

    const response = await axiosProvider({
      method,
      endpoint: `ManageHeaderMenu`,
      data: submitFormData,
      logData: values,
      oldData: editData,
      location: location?.pathname,
      userId
    })
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data?.code === 200) {
            fetchData()
            setEditData()
            resetForm({ values: '' })
          }
        }
        setModalShow(false)
        setToast({
          show: true,
          text: res?.data?.message,
          variation: res?.data?.code !== 200 ? 'error' : 'success'
        })

        setTimeout(() => {
          setToast({ ...toast, show: false })
        }, 2000)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const validationSchema = Yup.object().shape(
    {
      name: Yup.string()
        .matches(_alphabetRegex_, 'Only alphabet allowed')
        .required('Please enter name'),
      hasLink: Yup.boolean(),
      sequence: Yup.string().required('Sequence is required'),
      redirectTo: Yup.string().when('hasLink', {
        is: (hasLink) => hasLink === true,
        then: () => Yup.string().required('Redirect to required'),
        otherwise: () => Yup.string().nullable()
      }),
      categoryId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Product List',
        then: () =>
          Yup.number()
            .moreThan(0, 'Product list required')
            .required('Product list required'),
        otherwise: () => Yup.string().nullable()
      }),
      staticPageId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Static Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Static page required')
            .required('Static page required'),
        otherwise: () => Yup.string().nullable()
      }),
      lendingPageId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Landing Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Landing page required')
            .required('Landing page required'),
        otherwise: () => Yup.string().nullable()
      }),
      collectionId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Collection Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Collection page required')
            .required('Collection page required'),
        otherwise: () => Yup.string().nullable()
      }),
      customLink: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Other Links',
        then: () => Yup.string().required('Other link required'),
        otherwise: () => Yup.string().nullable()
      }),
      imageFile: Yup.mixed().when('imageFile', {
        is: (value) => value?.name,
        then: (schema) =>
          schema
            .test(
              'fileFormat',
              'File formate is not supported, Please use .jpg/.png/.jpeg format support',
              (value) => value && SUPPORTED_FORMATS.includes(value.type)
            )
            .test('fileSize', 'File must be less than 2MB', (value) => {
              return value !== undefined && value && value.size <= 2000000
            }),
        otherwise: (schema) => schema.nullable()
      })
    },
    ['imageFile', 'imageFile']
  )

  const initialValues = {
    name: '',
    image: '',
    imageAlt: '',
    hasLink: false,
    redirectTo: '',
    lendingPageId: 0,
    categoryId: 0,
    staticPageId: 0,
    collectionId: 0,
    customLink: '',
    id: null,
    sequence: ''
  }

  const prepareEditData = () => {
    let data = editData
    switch (editData?.redirectTo) {
      case 'Product List':
        data = { ...editData, dropDownId: 'categoryId' }
        break

      case 'Static Page':
        data = { ...editData, dropDownId: 'staticPageId' }
        break

      case 'Landing Page':
        data = { ...editData, dropDownId: 'lendingPageId' }
        break

      case 'Collection Page':
        data = { ...editData, dropDownId: 'collectionId' }
        break

      default:
        break
    }
    return data
  }

  const initialValuesEdit = editData && prepareEditData()

  const getIdName = (values) => {
    let idName = ''
    switch (values?.redirectTo) {
      case 'Product List':
        idName = 'categoryId'
        break

      case 'Static Page':
        idName = 'staticPageId'
        break

      case 'Landing Page':
        idName = 'lendingPageId'
        break

      case 'Collection Page':
        idName = 'collectionId'
        break

      default:
        break
    }

    return idName
  }

  const checkRedirectTo = (redirectTo) => {
    switch (redirectTo) {
      case 'Product List':
        return 'categoryId'

      case 'Static Page':
        return 'staticPageId'

      case 'Landing Page':
        return 'lendingPageId'

      case 'Collection Page':
        return 'collectionId'
    }
  }

  return (
    <Formik
      initialValues={editData ? initialValuesEdit : initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        values,
        setFieldValue,
        setErrors,
        setTouched,
        resetForm,
        errors
      }) => (
        <Form id='mainBrand'>
          <ModelComponent
            show={modalShow}
            className='fade-modal-for-date modal-backdrop'
            modalsize={'md'}
            modeltitle={'Manage menu '}
            onHide={() => {
              setEditData()
              setModalShow(!modalShow)
              resetForm({ values: '' })
            }}
            backdrop={'static'}
            formbuttonid={'mainBrand'}
            submitname={editData ? 'Update' : 'Create'}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            formik={{ values, setFieldValue, setErrors, setTouched, resetForm }}
          >
            <div className='row manage_banner_modal'>
              {loading && <Loader />}
              <div className='col-md-3'>
                <div className='input-file-wrapper m--cst-filetype mb-3'>
                  <label className='form-label d-block' htmlFor='logo'>
                    Image
                  </label>
                  <input
                    id='filename'
                    className='form-control'
                    name='logo'
                    type='file'
                    accept='image/jpg, image/png, image/jpeg'
                    onChange={(event) => {
                      const objectUrl = URL.createObjectURL(
                        event.target.files[0]
                      )
                      if (event.target.files[0].type !== '') {
                        setFieldValue('image', objectUrl)
                      }
                      setFieldValue(
                        'imageFile',
                        event?.target?.files[0] ? event?.target?.files[0] : ''
                      )
                    }}
                    hidden
                  />
                  {values?.image ? (
                    <div className='position-relative m--img-preview d-flex rounded-2 overflow-hidden'>
                      <img
                        src={
                          values?.image?.includes('blob')
                            ? values?.image
                            : `${process.env.REACT_APP_IMG_URL}${_headerMenuImg_}${values?.image}`
                        }
                        alt='Preview Image'
                        title={values?.image ? values?.imageFile?.name : ''}
                        className='rounded-2'
                      ></img>
                      <span
                        onClick={(e) => {
                          setFieldValue('image', null)
                          setFieldValue('imageFile', '')
                          document.getElementById('filename').value = null
                        }}
                      >
                        <i className='m-icon m-icon--close'></i>
                      </span>
                    </div>
                  ) : (
                    <>
                      <label
                        className='m__image_default d-flex align-items-center justify-content-center rounded-2'
                        htmlFor='filename'
                      >
                        <i className='m-icon m-icon--defaultpreview'></i>
                      </label>
                    </>
                  )}
                  <ErrorMessage
                    name='imageFile'
                    component={TextError}
                    customclass={'cfz-12 lh-sm'}
                  />
                </div>
              </div>
              <div className='col-md-9'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='input-file-wrapper mb-3'>
                      <FormikControl
                        control='input'
                        label='Name'
                        isRequired
                        id='name'
                        type='text'
                        name='name'
                        placeholder='Name'
                        onBlur={(e) => {
                          let fieldName = e?.target?.name
                          setFieldValue(fieldName, values[fieldName]?.trim())
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <FormikControl
                      label='Image Alt'
                      control='input'
                      type='text'
                      name='imageAlt'
                      placeholder='Image Alt'
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                    />
                  </div>
                  <div className='col-md-6'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='Sequence'
                      type='text'
                      name='sequence'
                      onChange={(e) => {
                        const inputValue = e?.target?.value
                        const isValid = _integerRegex_.test(inputValue)
                        const fieldName = e?.target?.name
                        if (isValid || !inputValue)
                          setFieldValue([fieldName], inputValue)
                      }}
                      placeholder='Sequence'
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className='col-md-4 mt-auto mb-3'>
                <label className='form-label'>Link</label>
                <InputGroup className='custom_checkbox '>
                  <InputGroup.Checkbox
                    id='hasLink'
                    name='hasLink'
                    checked={values?.hasLink}
                    onChange={(e) => {
                      if (!e?.target?.checked) {
                        setFieldValue('redirectTo', '')
                        setFieldValue('categoryId', 0)
                        setFieldValue('lendingPageId', 0)
                        setFieldValue('staticPageId', 0)
                        setFieldValue('collectionId', 0)
                      }
                      setFieldValue('hasLink', e?.target?.checked)
                    }}
                  />
                  <label className='custom_label' htmlFor='hasLink'>
                    Has Link
                  </label>
                </InputGroup>
                <ErrorMessage name='hasLink' component={TextError} />
              </div>

              <div className='col-md-8'>
                {values?.hasLink && (
                  <div className='input-file-wrapper mb-3'>
                    <label className='form-label required'>Redirect To</label>
                    <ReactSelect
                      id='redirectTo'
                      name='redirectTo'
                      placeholder='Redirect To'
                      defaultValue={
                        !editData
                          ? null
                          : {
                              value: values.redirectTo,
                              label: values.redirectTo
                            }
                      }
                      options={redirectTo}
                      onChange={(e) => {
                        setFieldValue('categoryId', 0)
                        setFieldValue('lendingPageId', 0)
                        setFieldValue('staticPageId', 0)
                        setFieldValue('collectionId', 0)
                        let endpoint = ''
                        switch (e?.value) {
                          case 'Product List':
                            setFieldValue('dropDownId', 'categoryId')
                            endpoint = 'MainCategory/getEndCategory'
                            break

                          case 'Static Page':
                            setFieldValue('dropDownId', 'staticPageId')
                            endpoint = 'ManageStaticPages'
                            break

                          case 'Landing Page':
                            setFieldValue('dropDownId', 'lendingPageId')
                            endpoint = 'LendingPage'
                            break

                          case 'Collection Page':
                            setFieldValue('dropDownId', 'collectionId')
                            endpoint = 'ManageCollection'
                            break

                          default:
                            break
                        }
                        endpoint &&
                          fetchDropDownData(
                            endpoint,
                            '?pageindex=0&PageSize=0',
                            (data) => {
                              setDropDownData(data)
                            }
                          )
                        setFieldValue('redirectTo', e?.value)
                      }}
                    />
                  </div>
                )}
              </div>
              {values?.redirectTo && (
                <>
                  <div className='col-md-12'>
                    <div className='input-file-wrapper mb-3'>
                      {values?.redirectTo === 'Other Links' ? (
                        <FormikControl
                          control='input'
                          label={values?.redirectTo}
                          isRequired
                          id='customLink'
                          type='text'
                          name='customLink'
                          value={values?.customLink}
                          placeholder='Custom Link'
                          onChange={(e) => {
                            setFieldValue('customLink', e?.target?.value)
                            setFieldValue('categoryId', 0)
                            setFieldValue('lendingPageId', 0)
                            setFieldValue('staticPageId', 0)
                            setFieldValue('collectionId', 0)
                          }}
                          onBlur={(e) => {
                            let fieldName = e?.target?.name
                            setFieldValue(fieldName, values[fieldName]?.trim())
                          }}
                        />
                      ) : (
                        <>
                          <label className='form-label required'>
                            {values?.redirectTo && values?.redirectTo}
                          </label>
                          <ReactSelect
                            id={checkRedirectTo(values?.redirectTo)}
                            name={checkRedirectTo(values?.redirectTo)}
                            placeholder={values?.redirectTo}
                            value={
                              dropDownData &&
                              values?.[values?.dropDownId] && {
                                value: dropDownData?.filter(
                                  (data) =>
                                    data?.id === values?.[values?.dropDownId]
                                )[0]?.id,
                                label: dropDownData?.filter(
                                  (data) =>
                                    data?.id === values?.[values?.dropDownId]
                                )[0]?.name
                              }
                            }
                            options={
                              dropDownData &&
                              dropDownData?.map(({ id, name }) => ({
                                value: id,
                                label: name
                              }))
                            }
                            onChange={(e) => {
                              setFieldValue('categoryId', 0)
                              setFieldValue('lendingPageId', 0)
                              setFieldValue('staticPageId', 0)
                              setFieldValue('collectionId', 0)
                              switch (values?.redirectTo) {
                                case 'Product List':
                                  setFieldValue('categoryId', e?.value)
                                  break
                                case 'Static Page':
                                  setFieldValue('staticPageId', e?.value)
                                  break
                                case 'Landing Page':
                                  setFieldValue('lendingPageId', e?.value)
                                  break
                                case 'Collection Page':
                                  setFieldValue('collectionId', e?.value)
                                  break
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </ModelComponent>
        </Form>
      )}
    </Formik>
  )
}

export default ManageBannerModel
